import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChevronRight, ExternalLink, Info } from 'lucide-angular';

@Component({
  selector: 'di-grid-card',
  templateUrl: './grid-card.component.html',
  standalone: false,
})
export class GridCardComponent {
  @Input() iconClass: string;
  @Input() isExternalLink: boolean;
  @Input() isCardDisabled: boolean;
  @Output() clickCard = new EventEmitter();

  readonly icons = { Info, ExternalLink, ChevronRight };
}
